var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLanguage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0752 18.684L16.9502 14.434L14.8252 18.684",
    stroke: "#EFEDF2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2002 17.934H18.7002",
    stroke: "#EFEDF2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9501 22V22C14.1611 22 11.9001 19.739 11.9001 16.95V16.95C11.9001 14.161 14.1611 11.9 16.9501 11.9V11.9C19.7391 11.9 22.0001 14.161 22.0001 16.95V16.95C22.0001 19.739 19.7391 22 16.9501 22Z",
    stroke: "#EFEDF2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.1001 2.09998H9.0001C10.6571 2.09998 12.0001 3.44298 12.0001 5.09998V8.99998C12.0001 10.657 10.6571 12 9.0001 12H5.1001C3.4431 12 2.1001 10.657 2.1001 8.99998V5.09998C2.1001 3.44298 3.4431 2.09998 5.1001 2.09998Z",
    stroke: "#EFEDF2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.07003 5.92999H5.03003",
    stroke: "#EFEDF2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.05005 5.24997V5.92997",
    stroke: "#EFEDF2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.06215 5.92499C8.06215 7.66499 6.70215 9.07499 5.02515 9.07499",
    stroke: "#EFEDF2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.07513 9.07495C8.34713 9.07495 7.69613 8.68695 7.23413 8.07495",
    stroke: "#EFEDF2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5649 4.91602H16.0309C18.0549 4.91602 19.6949 6.55702 19.6949 8.58002",
    stroke: "#EFEDF2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5649 4.91602L15.6639 6.01502",
    stroke: "#EFEDF2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6639 3.81598L14.5649 4.91498",
    stroke: "#EFEDF2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.43493 19.084H7.96893C5.94493 19.084 4.30493 17.443 4.30493 15.42",
    stroke: "#EFEDF2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.43494 19.084L8.33594 17.985",
    stroke: "#EFEDF2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33594 20.184L9.43494 19.085",
    stroke: "#EFEDF2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguage);
export default __webpack_public_path__ + "static/media/Language.4374a7860feca1f64076d8646e1130ce.svg";
export { ForwardRef as ReactComponent };